import { StyledGiantBox } from "../../commons/Content.styles";

const ResumePage = ({ isMenuClicked }) => (
  <StyledGiantBox isMenuClicked={isMenuClicked}>
    Resume
  </StyledGiantBox>
);

export default ResumePage;